// custom code start
(function () {
  var Tracking = window.Tracking || {};
  window.Tracking = Tracking;

  // user_id is the ERP customer id (customer.metafields.erp.customer_id).
  // shopify_customer_id is the Shopify one. The two are never conflated —
  // storefront and checkout must agree on which is which.
  Tracking.userId = Tracking.userId || null;
  Tracking.shopifyCustomerId = Tracking.shopifyCustomerId || null;
  Tracking.productCache = Tracking.productCache || {};
  Tracking.init = Tracking.init || {};

  var CACHE_KEY = 'tracking:productCache';
  var ATTRIBUTION_KEY = 'tracking:productAttribution';

  window.dataLayer = window.dataLayer || [];

  function readJSON(key) {
    try {
      var raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeJSON(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  // Restore productCache so items added on previous pages (different collection,
  // PDP, etc.) still resolve when the drawer opens.
  var storedCache = readJSON(CACHE_KEY);
  if (storedCache && typeof storedCache === 'object') {
    Object.keys(storedCache).forEach(function (k) {
      if (!Tracking.productCache[k]) Tracking.productCache[k] = storedCache[k];
    });
  }

  /* ---- attribution store --------------------------------------------------
     item_list_id/item_list_name are locked to the FIRST surface a product was
     seen on in this session and reused on every later event, so a product first
     met in a collection still reports that collection at add_to_cart and
     purchase.

     item_category* behave differently on purpose: they must match the
     breadcrumb currently on screen, so whatever the page rendered wins. The
     stored copy is only a fallback for surfaces that have no breadcrumb of
     their own — cart drawer, cart page, checkout.                          */
  var attribution = readJSON(ATTRIBUTION_KEY) || {};

  function handleFromUrl(url) {
    if (!url) return '';
    var match = String(url).match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }
  Tracking.handleFromUrl = handleFromUrl;

  Tracking.remember = function (handle, data) {
    if (!handle || !data) return;
    var entry = attribution[handle] || {};
    var changed = false;

    // First non-empty list wins and is never overwritten.
    if (!entry.item_list_id && data.item_list_id) {
      entry.item_list_id = data.item_list_id;
      entry.item_list_name = data.item_list_name || '';
      entry.first_seen = Date.now();
      changed = true;
    }

    // Category follows the most recent breadcrumb the shopper actually saw.
    if (data.item_category && data.item_category !== entry.item_category) {
      entry.item_category = data.item_category;
      entry.item_category2 = data.item_category2 || '';
      entry.item_category3 = data.item_category3 || '';
      changed = true;
    }

    if (changed) {
      attribution[handle] = entry;
      writeJSON(ATTRIBUTION_KEY, attribution);
    }
  };

  Tracking.getAttribution = function (handle) {
    return (handle && attribution[handle]) || null;
  };

  // Records the sighting, then reconciles the item against what is stored.
  Tracking.applyAttribution = function (item) {
    if (!item) return item;
    var handle = handleFromUrl(item.url);
    if (!handle) return item;

    Tracking.remember(handle, item);
    var entry = attribution[handle];

    if (entry && entry.item_list_id) {
      item.item_list_id = entry.item_list_id;
      item.item_list_name = entry.item_list_name || '';
    } else {
      delete item.item_list_id;
      delete item.item_list_name;
    }

    // Fall back to the last breadcrumb seen only when this page rendered none.
    if (!item.item_category && entry && entry.item_category) {
      item.item_category = entry.item_category;
      item.item_category2 = entry.item_category2 || '';
      item.item_category3 = entry.item_category3 || '';
    }

    // No breadcrumb has ever applied to this product — send no category at all.
    if (!item.item_category) {
      delete item.item_category;
      delete item.item_category2;
      delete item.item_category3;
    } else {
      if (!item.item_category2) delete item.item_category2;
      if (!item.item_category3) delete item.item_category3;
    }

    return item;
  };

  function cacheItems(items) {
    if (!Array.isArray(items)) return;
    var changed = false;
    items.forEach(function (item) {
      var handle = item && handleFromUrl(item.url);
      if (!handle) return;
      // A free cart line's 0 is not the product's price, and select_item reads this cache.
      if (item.price === 0 && item.original_price > 0) return;
      Tracking.productCache[handle] = item;
      changed = true;
    });
    if (changed) writeJSON(CACHE_KEY, Tracking.productCache);
  }

  Tracking.push = function (payload) {
    if (!payload || !payload.event) return;

    if (payload.event === 'user_data') {
      if (payload.user_id) Tracking.userId = payload.user_id;
      if (payload.shopify_customer_id) Tracking.shopifyCustomerId = payload.shopify_customer_id;
    }

    // Identity rides on every event, so individual emitters never hand-roll it.
    if (Tracking.userId && payload.user_id == null) {
      payload.user_id = Tracking.userId;
    }
    if (Tracking.shopifyCustomerId && payload.shopify_customer_id == null) {
      payload.shopify_customer_id = Tracking.shopifyCustomerId;
    }

    if (payload.ecommerce && Array.isArray(payload.ecommerce.items)) {
      payload.ecommerce.items.forEach(function (item) {
        Tracking.applyAttribution(item);
      });
      cacheItems(payload.ecommerce.items);
      // GA4 best practice: reset ecommerce before every ecommerce event
      // Prevents items[] from previous events merging into the current one
      window.dataLayer.push({ ecommerce: null });
    }

    window.dataLayer.push(payload);
  };

  var islands = document.querySelectorAll(
    'script[type="application/json"][id^="datalayer-"]'
  );

  for (var i = 0; i < islands.length; i++) {
    // user_data / page_data / shopify_page_view are pushed synchronously in the
    // head by snippets/datalayer.liquid so they beat the GTM container. Skip
    // those here rather than sending them a second time.
    if (islands[i].getAttribute('data-dl-pushed')) continue;
    var raw = islands[i].textContent;
    if (!raw) continue;
    try {
      Tracking.push(JSON.parse(raw));
    } catch (e) {
      // A malformed island silently drops a revenue-critical event, so make it
      // loud on both the console and the dataLayer instead of warning quietly.
      if (window.console && console.error) {
        console.error('[Tracking] island parse error — event dropped:', islands[i].id, e);
      }
      window.dataLayer.push({
        event: 'tracking_error',
        tracking_error_source: islands[i].id,
        tracking_error_message: String((e && e.message) || e),
      });
    }
  }
})();
// custom code end
